import { render, staticRenderFns } from "./UserDepartmentsViewSidebar.vue?vue&type=template&id=16c73aad&scoped=true"
import script from "./UserDepartmentsViewSidebar.vue?vue&type=script&lang=js"
export * from "./UserDepartmentsViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserDepartmentsViewSidebar.vue?vue&type=style&index=0&id=16c73aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c73aad",
  null
  
)

export default component.exports